import { Action, ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import * as fromReducers from '@app/store/reducers';
import { logoutSuccess } from '@app/store/actions';

export interface State {
    [fromReducers.recordsKey]: fromReducers.RecordsState;
    [fromReducers.uiKey]: fromReducers.UIState;
    [fromReducers.worklistKey]: fromReducers.WorklistState;
}

export const reducers: ActionReducerMap<State> = {
    [fromReducers.recordsKey]: fromReducers.recordsReducer,
    [fromReducers.uiKey]: fromReducers.uiReducer,
    [fromReducers.worklistKey]: fromReducers.worklistReducer,
};

export function storeResetMetaReducer(reducer: ActionReducer<State>): ActionReducer<State> {
    return (state: State | undefined, action: Action): State => {
        if (action.type === logoutSuccess.type) {
            return reducer(undefined, action);
        }
        return reducer(state, action);
    };
}

export const metaReducers: MetaReducer<State>[] = [storeResetMetaReducer];
